<template>
  <a-card :bordered="false">
    <div class="table-operator" style="margin-bottom:12px;">
      <h-select v-model="query.payChannel" placeholder="支付渠道" style="width:150px;" :options="channelOpts" @change="load"/>
      <a-input-search v-model="query.mchId" placeholder="商户号 mch_id" style="width:200px;margin-left:8px;" @search="load"/>
      <a-input-search v-model="query.outTradeNo" placeholder="商户订单号 out_trade_no" style="width:220px;margin-left:8px;" @search="load"/>
      <h-select v-model="query.status" placeholder="接收状态" style="width:140px;margin-left:8px;" :options="statusOpts" @change="load"/>
      <h-select v-model="query.processStatus" placeholder="业务处理状态" style="width:160px;margin-left:8px;" :options="procOpts" @change="load"/>
      <a-range-picker style="margin-left:8px;" v-model="query.dateRage" @change="load"/>
      <a-button type="primary" icon="search" style="margin-left:8px;" @click="load">查询</a-button>
      <a-button icon="sync" style="margin-left:8px;" @click="load">刷新</a-button>
    </div>

    <a-table bordered size="middle" rowKey="id" :columns="cols" :dataSource="rows" :loading="loading" :pagination="pag" @change="(p)=>{pag.current=p.current;pag.pageSize=p.pageSize;load();}">
      <template slot="ch_slot" slot-scope="t"><a-tag v-if="t">{{ t }}</a-tag><span v-else class="muted">—</span></template>
      <template slot="st_slot" slot-scope="t">
        <a-tag v-if="t==='SUCCESS'" color="green">接收成功</a-tag>
        <a-tag v-else-if="t==='SIGN_FAIL'" color="red">验签失败</a-tag>
        <a-tag v-else-if="t==='DUP'" color="orange">重复请求</a-tag>
        <a-tag v-else-if="t==='FAIL'" color="red">格式非法</a-tag>
        <span v-else class="muted">{{ t || '—' }}</span>
      </template>
      <template slot="pr_slot" slot-scope="t">
        <a-tag v-if="t==='CREATED'" color="blue">已入队</a-tag>
        <a-tag v-else-if="t==='DONE'" color="green">已生成转账单</a-tag>
        <a-tag v-else-if="t==='VOUCHERED'" color="purple">已生成凭证</a-tag>
        <a-tag v-else-if="t==='IGNORED'" color="default">已忽略</a-tag>
        <a-tag v-else-if="t==='ERROR'" color="red">处理异常</a-tag>
        <span v-else class="muted">{{ t || '—' }}</span>
      </template>
      <template slot="amt_slot" slot-scope="t"><span class="mono">{{ t==null?'—':Number(t).toFixed(2) }}</span></template>
      <template slot="action" slot-scope="t, r">
        <a @click="openDetail(r)">详情</a>
        <a-divider type="vertical"/>
        <a v-if="r.process_status==='ERROR'||r.process_status==='CREATED'" @click="retry(r)">重试处理</a>
      </template>
    </a-table>

    <!-- 详情 Drawer -->
    <a-drawer title="回调详情" placement="right" :width="680" :visible="drawer" @close="drawer=false">
      <a-descriptions bordered size="small" :column="1" v-if="detail">
        <a-descriptions-item label="回调时间">{{ detail.notify_time }}</a-descriptions-item>
        <a-descriptions-item label="租户ID / 支付渠道">{{ detail.tenant_id }} / {{ detail.pay_channel }}</a-descriptions-item>
        <a-descriptions-item label="商户号 / AppId">{{ detail.mch_id }} / {{ detail.app_id || '—' }}</a-descriptions-item>
        <a-descriptions-item label="商户订单号">{{ detail.out_trade_no }}</a-descriptions-item>
        <a-descriptions-item label="三方交易号 transaction_id">{{ detail.transaction_id || '—' }}</a-descriptions-item>
        <a-descriptions-item label="金额(元) / 手续费">{{ Number(detail.amount||0).toFixed(2) }} / {{ detail.fee_amount==null?'—':Number(detail.fee_amount).toFixed(2) }}</a-descriptions-item>
        <a-descriptions-item label="接收状态 / 幂等键">{{ detail.status }} / {{ detail.idempotency_key || '—' }}</a-descriptions-item>
        <a-descriptions-item label="业务处理 / 关联转账单 / 凭证">{{ detail.process_status }} / {{ detail.account_head_id || '—' }} / {{ detail.voucher_id || '—' }}</a-descriptions-item>
        <a-descriptions-item label="错误信息" v-if="detail.error_msg"><span class="text-red">{{ detail.error_msg }}</span></a-descriptions-item>
        <a-descriptions-item label="原始报文(raw_body)">
          <textarea readonly rows="6" style="width:100%;font-family:Consolas,monospace;font-size:12px;">{{ detail.raw_body || '' }}</textarea>
        </a-descriptions-item>
      </a-descriptions>
    </a-drawer>
  </a-card>
</template>

<script>
import { payCallbackLogList } from './api'

export default {
  name: 'PaymentCallbackLogList',
  data() {
    return {
      loading: false, drawer: false, detail: null,
      query: { payChannel: undefined, mchId: undefined, outTradeNo: undefined, status: undefined, processStatus: undefined, dateRage: [] },
      pag: { current: 1, pageSize: 20, total: 0 },
      rows: [],
      channelOpts: [
        { value: '', label: '全部' },
        { value: 'wechat', label: '微信支付' }, { value: 'alipay', label: '支付宝' },
        { value: 'unionpay', label: '银联' }, { value: 'other', label: '其他' }
      ],
      statusOpts: [
        { value: '', label: '全部' },
        { value: 'SUCCESS', label: '接收成功' }, { value: 'SIGN_FAIL', label: '验签失败' },
        { value: 'DUP', label: '重复请求' }, { value: 'FAIL', label: '格式非法' }
      ],
      procOpts: [
        { value: '', label: '全部' },
        { value: 'CREATED', label: '已入队' }, { value: 'DONE', label: '已生成转账单' },
        { value: 'VOUCHERED', label: '已生成凭证' }, { value: 'IGNORED', label: '已忽略' },
        { value: 'ERROR', label: '处理异常' }
      ],
      cols: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 140, fixed: 'left' },
        { title: '时间', dataIndex: 'notify_time', width: 160 },
        { title: '支付渠道', dataIndex: 'pay_channel', scopedSlots: { customRender: 'ch_slot' }, width: 100 },
        { title: '商户号', dataIndex: 'mch_id', width: 150 },
        { title: '商户订单号', dataIndex: 'out_trade_no', width: 200 },
        { title: '三方交易号', dataIndex: 'transaction_id', width: 220 },
        { title: '金额(元)', dataIndex: 'amount', scopedSlots: { customRender: 'amt_slot' }, width: 110 },
        { title: '接收', dataIndex: 'status', scopedSlots: { customRender: 'st_slot' }, width: 110 },
        { title: '业务处理', dataIndex: 'process_status', scopedSlots: { customRender: 'pr_slot' }, width: 130 },
        { title: '转账单/凭证', dataIndex: '_links', width: 160, customRender: (h, r) => h('span', [
          h('span', { attrs: { class: 'mono' } }, [String(r.account_head_id||'—') + ' / ' + String(r.voucher_id||'—')])
        ])}
      ]
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      const d = this.query.dateRage || []
      const df = d.length === 2 ? d[0].format('YYYY-MM-DD') : null
      const dt = d.length === 2 ? d[1].format('YYYY-MM-DD') : null
      const p = {
        page: this.pag.current, pageSize: this.pag.pageSize,
        payChannel: this.query.payChannel, mchId: this.query.mchId,
        outTradeNo: this.query.outTradeNo, status: this.query.status,
        processStatus: this.query.processStatus, dateFrom: df, dateTo: dt
      }
      payCallbackLogList(p).then(r => {
        this.loading = false
        if (r && r.success) {
          const d = r.data || {}
          this.rows = d.rows || []
          this.pag.total = d.total || 0
        } else { this.$message.error((r && r.message) || '查询失败') }
      }).catch(() => { this.loading = false; this.$message.error('请求失败') })
    },
    openDetail(r) { this.detail = r; this.drawer = true },
    retry(r) {
      this.$message.info('本期为回调骨架版本，实际重试将在三方支付对接版本中实现')
    }
  }
}
</script>

<style scoped>
.muted{color:#999;}
.mono{font-family:Consolas,monospace;}
.text-red{color:#f5222d;}
</style>
